<template>
    <v-card>
        <v-card-title>Please provide any Additional Information/Questions below.</v-card-title>
        <v-card-text>
            <p class="text-subtitle-1">If you have an special equipment request, please add them in notes below. Please be
                as
                specific as possible, we will contact you if we have question.</p>
            <v-textarea
                :max="200"
                v-model="reservation.additional_info"
                auto-grow
                outlined
                rows="4"
            ></v-textarea>
        </v-card-text>

    </v-card>
</template>

<script>
import ValidatableComponent from "../../mixins/ValidatableComponent";
import WithValidation       from "../../components/inputs/WithValidation";

export default {
    name      : "AdditionalInformationInput",
    components: {WithValidation},
    mixins:[ValidatableComponent],
   computed:{
       reservation() {
           return this.$store.state.model.reservation;
       },
   }
}
</script>

<style scoped>

</style>
